var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnitDetailsEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#4D4949"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_349_2196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1208 13.4701C12.8173 13.6725 12.4647 13.7794 12.1012 13.7794C11.7377 13.7794 11.3852 13.6725 11.0817 13.4701L6.08245 10.1372C6.05471 10.1187 6.02769 10.0994 6.00122 10.0796V15.5409C6.00122 16.1671 6.50936 16.664 7.12431 16.664H17.0781C17.7043 16.664 18.2012 16.1559 18.2012 15.5409V10.0796C18.1747 10.0995 18.1476 10.1188 18.1198 10.1373L13.1208 13.4701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47897 9.54448L11.4782 12.8774C11.6674 13.0036 11.8843 13.0667 12.1012 13.0667C12.3181 13.0667 12.535 13.0036 12.7243 12.8774L17.7235 9.54448C18.0226 9.34516 18.2012 9.01156 18.2012 8.65152C18.2012 8.03244 17.6976 7.52881 17.0785 7.52881H7.12393C6.50488 7.52883 6.00122 8.03246 6.00122 8.65211C6.00122 9.01156 6.17984 9.34516 6.47897 9.54448Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_349_2196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.2,
    height: 12.2,
    fill: "white",
    transform: "translate(5.99951 5.99951)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitDetailsEmailIcon);
export default __webpack_public_path__ + "static/media/unit-details-email-icon.710b113a163747538979cee4503fb86e.svg";
export { ForwardRef as ReactComponent };